import { CircularProgress, Stack } from '@mui/material'

import { useProject } from '../../api/project'
import { useSignup } from '../../context/signup'
import { useProjectId } from '../../hooks/useProjectId'
import { EndPage } from '../endPage'
import { InterestSignupForm } from '../interestSignupForm'
import { InterestsPage } from '../interestsPage'
import { NotFound } from '../notFound'
import { SalesStartSignupForm } from '../salesStartSignupForm'
import { SignupClosed } from '../signupClosed'
import { SignupUnopened } from '../signupUnopened'
import { StartPage } from '../startPage'
import { derivePages } from './derivePages'

export const UnopenedPage = (props) => <SignupUnopened {...props} />

export const UserPage = (props) => {
  if (props?.project?.interestSignup) {
    return <InterestSignupForm {...props} />
  }
  return <SalesStartSignupForm {...props} />
}

const ClosedPage = (props) => <SignupClosed {...props} />

export const Signup = () => {
  const projectId = useProjectId()
  const { data: project, isPending } = useProject(projectId)
  const { index } = useSignup()

  // isPending also covers the disabled query outside a project route.
  const pages = isPending ? [] : derivePages(project)
  const currentPage = pages.length && pages[index]

  switch (currentPage) {
    case 'NOT_FOUND':
      return <NotFound />
    case 'UNOPENED':
      return <UnopenedPage project={project} />
    case 'START':
      return <StartPage />
    case 'USER':
      return <UserPage project={project} />
    case 'INTERESTS':
      return <InterestsPage />
    case 'END':
      return <EndPage />
    case 'CLOSED':
      return <ClosedPage project={project} />
  }
  return (
    <Stack alignItems="center" justifyContent="center">
      <CircularProgress />
    </Stack>
  )
}
